import Home from "./dienlanhsaigon/Home/Home";
import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homerut from "./Rut/Homerut";
import Maylanh from "./dienlanhsaigon//Maylanh/Maylanh";
import Tulanh from "./dienlanhsaigon/Tulanh/Tulanh";
import Maygiat from "./dienlanhsaigon/Maygiat/Maygiat";
import Tivi from "./dienlanhsaigon/Tivi/Tivi";
import Privacy from "./dienlanhsaigon/Privacy/Privacy";
import Tuyendung from "./Tuyen-dung/Tuyendung";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Homerut />} />
          <Route path="/nhanuudai" element={<Homerut />} />
          <Route path="/baophi" element={<Homerut />} />
          <Route path="/so1" element={<Homerut />} />
          <Route path="/rutonline" element={<Homerut />} />
          <Route path="/rutnhanh" element={<Homerut />} />
          <Route path="/quytrinhrut" element={<Homerut />} />
          <Route path="/dien-lanh" element={<Home />} />
          <Route path="/maylanh" element={<Maylanh />} />
          <Route path="/tulanh" element={<Tulanh />} />
          <Route path="/maygiat" element={<Maygiat />} />
          <Route path="/tivi" element={<Tivi />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/tuyendung" element={<Tuyendung />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
